(function () {
    'use strict';

    function documentResourcesGroupConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/documentResourcesGroupConfiguration.html',
            link: function (scope) {
            }
        };
    }

    documentResourcesGroupConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('documentResourcesGroupConfiguration', documentResourcesGroupConfiguration);
})();

